import { IHttpService } from "../../core/service/HttpService";
import SearchQuery from "../model/SearchResultSummary";
import SearchResponse from "../model/SearchResponse";

export interface ISearchService {
  simpleSearch(query: string | TSearchQueryRequest): Promise<any>;
  search(query: TSearchQueryRequest): Promise<any>;
}

export type TSearchSortOrder = "asc" | "desc";

export type TSearchQueryRequest = {
  phrase?: string;
  year?: string;
  decision_date?: string;
  organisation?: string;
  organisation_id?: string;
  ccn?: string;
  index?: string;
  sortField?: string;
  sortOrder?: TSearchSortOrder;
  pageSize?: number;
  page?: number;
  status?: string;
  type?: "simple" | "advanced";
  collection?: string;
};

const SearchService = ({ httpService }): ISearchService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _simpleSearchPath: string = "search/simple";
  const _searchPath: string = "search/advanced";

  return {
    async simpleSearch(query: string | TSearchQueryRequest) {
      const path = _http.buildPath(_baseUrl, _simpleSearchPath);
      const searchParams =
        typeof query === "string"
          ? { q: query }
          : {
              q: query.phrase,
              organisation: query.organisation,
              year: query.year,
              index: query.index,
              ccn: query.ccn,
              sort_field: query.sortField,
              sort_order: query.sortOrder,
              page_size: query.pageSize,
              page: query.page,
              status: query.status,
              decision_date: query.decision_date,
              collection: query.collection
            };
      const response = await _http.get(path, {
        params: searchParams
      });
      const { searchCriteria, ...queryResponse } = await _http.toJSON(response);
      let _query = SearchQuery(searchCriteria);
      return SearchResponse({ ...queryResponse, query: _query });
    },
    async search(query: TSearchQueryRequest) {
      const path = _http.buildPath(_baseUrl, _searchPath);
      const searchParams = query;
      const response = await _http.get(path, {
        params: searchParams
      });
      const { searchCriteria, ...queryResponse } = await _http.toJSON(response);
      let _query = SearchQuery(searchCriteria);
      return SearchResponse({ ...queryResponse, query: _query });
    }
  };
};

export default SearchService;
